define('views/pages/claims/collection',['require','jquery','views/base/collection','views/pages/claims/collection-item','text!templates/pages/claims/collection.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        CollectionView = require('views/base/collection'),
        ClaimCollectionItemView = require('views/pages/claims/collection-item'),
        template = require('text!templates/pages/claims/collection.ejs');

    var ClaimCollectionView = CollectionView.extend({
        template: template,
        itemView: ClaimCollectionItemView,
        loadingSelector: '.loading',
        fallbackSelector: '.empty',
        listSelector: 'tbody',
        listen: {
            'resize model': 'onResize',
            'addedToDOM': 'onResize'
        },
        onResize: function() {
            var h = $('body').height();
            var $b = this.$('tbody');
            $b.css('height', h - $b.offset().top - 12);
        }
    });

    return ClaimCollectionView;
});

